import {useEffect, useState} from 'react'
import { COLORS } from '../../config'
import { MoonLoader } from 'react-spinners'
import useScans from '../../store/scans/scansContext'
import FieldWithEdit from '../../components/FieldItems/FieldWithEdit';

function DicomStudyData({scanId}) {
  const {
    getDicomStudyData
  } = useScans();

  const [studyData, setStudyData] = useState({})
  const [patientData, setPatientData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
    
  useEffect(() => {
    if (!scanId) return;
    setIsLoading(true)
    getDicomStudyData(scanId).then(res => {
      setStudyData(res.dicom);
      setPatientData(res.patient);
      setIsLoading(false)
    })
  }, [scanId])

  return (
    <>
        <div className="bg-white rounded shadow py-12 px-10 mb-5">
          <div className="flex justify-between items-center">
            <h1 className="mb-10 text-2xl text-secondary">Study data</h1>
          </div>
          {isLoading ? <div className='flex justify-around min-h-170 pt-8'>
              <MoonLoader color={COLORS.colorPrimary}/>
            </div> : 
            <div className="grid grid-cols-1 gap-y-4">
              {studyData.length ? studyData.map(obj => <FieldWithEdit label={obj.key} data={obj.value} />) : <p>'No data provided'</p>}
            </div>      
          }
        </div>
        <div className="bg-white rounded shadow py-12 px-10 mb-5">
          <div className="flex justify-between items-center">
            <h1 className="mb-10 text-2xl text-secondary">Patient data</h1>
          </div>
          {isLoading ? <div className='flex justify-around min-h-170 pt-8'>
              <MoonLoader color={COLORS.colorPrimary}/>
            </div> :
            <div className="grid grid-cols-1 gap-y-4">
              {patientData.length ? patientData.map(obj => <FieldWithEdit label={obj.key} data={obj.value} />) : <p>'No data provided'</p>}
            </div>
          }
        </div>
      </>
  )
}

export default DicomStudyData